import { Box, Typography } from '@mui/material';
import CalendlyEmbeded from '@/domains/Demo/components/CalendlyEmbeded/CalendlyEmbeded';
import BgImage from 'public/images/for-employers/main/hero.png';
import { Container } from '@/components/layout';

const HeroSection: React.FC<{ isMobile: boolean; description: string }> = ({
  isMobile,
  children,
  description,
}) => {
  return (
    <Box sx={{ backgroundColor: '#F3F4F8' }} width="100%">
      <Container
        style={{
          paddingRight: '16px',
          paddingTop: isMobile ? '80px' : '100px',
          paddingBottom: isMobile ? '80px' : '100px',
        }}
      >
        <Box
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column-reverse' : 'row',
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ maxWidth: '520px' }}>
            <Box
              sx={{
                fontSize: '50px',
                fontWeight: 700,
                lineHeight: '59px',
                mb: '24px',
              }}
            >
              Employee support for life’s unexpected moments.
            </Box>
            <Typography mb="40px" variant="body1" component="p">
              {description}
            </Typography>
            <CalendlyEmbeded>Book a Demo</CalendlyEmbeded>
          </Box>
          <Box>
            <img src={BgImage} alt="" />
          </Box>
        </Box>
        {children ? (
          <Box
            sx={{
              marginTop: '57px',
              paddingTop: '57px',
              borderTop: isMobile ? '0px' : '1px solid rgba(0, 0, 0, 0.2)',
            }}
          >
            {children}
          </Box>
        ) : null}
      </Container>
    </Box>
  );
};

export default HeroSection;
